import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	FreudIconModule,
	FreudTooltipModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { CGISeverity } from './cgi-severity.component';

@NgModule({
	declarations: [CGISeverity],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FormsModule,
		FreudIconModule,
		FreudTypographyModule,
		FreudTooltipModule,
	],
	exports: [CGISeverity],
	providers: [],
})
export class CGISeverityModule {}
